export function getSeries() {
  return [
    {
      name: 'Lorem ipsum-1',
      data: [35, 46, 27, 55, 42, 21, 70, 51],
    },
    {
      name: 'Lorem ipsum-2',
      data: [35, 46, 27, 55, 42, 21, 70, 51],
    },
    {
      name: 'Lorem ipsum-2',
      data: [35, 46, 27, 55, 42, 21, 70, 51],
    },
  ];
}

export function getSingleSeries() {
  return [
    {
      name: 'Lorem ipsum-11',
      data: [35, 46, 27, 55, 42, 21, 70, 51],
    },
  ];
}

export function getDonutSeries() {
  return [
    {
      data: [35, 46, 27],
    },
  ];
}

export function getCategoriesDonut() {
  return ['Lorem ipsum 1', 'Lorem ipsum 1 Longer Text very long text test what will it do', 'Lorem ipsum 1'];
}

export function getEmptySeries() {
  return [];
}

export function getCategories() {
  return ['Dec 1', 'Dec 8', 'Dec 10', 'Ian 2', 'Feb 10', 'Feb 20', 'Feb 29', 'March 20'];
}

export function getCustomChartColors() {
  return {
    lineColor: ['#379FE3'],
    fillColor: ['#C3C6F3'],
  };
}

export function getEmptyColorsChartColors() {
  return {
    lineColor: ['var(--grey-layout-203-dark-theme-disabled-text)'],
    fillColor: ['var(--grey-layout-203-dark-theme-disabled-text)'],
  };
}
